import { proceduresConditionsSlice } from "./proceduresConditionsSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = proceduresConditionsSlice;
const moduleUrl = '/api/pricing/pricingProcedures/conditionType'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
